import { useEffect } from 'react';

/**
 * Toast Notification Component
 * Displays auto-dismissing notifications in the top-right corner
 * 
 * Props:
 * - message: string - The notification message
 * - type: 'success' | 'error' | 'info' - Notification type (default: 'info')
 * - duration: number - Auto-dismiss duration in ms (default: 3500)
 * - onClose: () => void - Called when toast is dismissed
 */
const Toast = ({ message, type = 'info', duration = 3500, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(onClose, duration);
    return () => clearTimeout(timer);
  }, [duration, onClose]);

  const bgColor = {
    success: 'bg-green-500',
    error: 'bg-red-500',
    info: 'bg-blue-500',
  }[type];

  const icon = {
    success: '✓',
    error: '✕',
    info: 'ℹ',
  }[type];

  return (
    <div
      className={`fixed top-4 right-4 max-w-sm ${bgColor} text-white px-4 py-3 rounded-lg shadow-lg flex items-center gap-3 animate-slide-in text-[13px] font-medium z-50`}
      role="alert"
    >
      <span className="text-lg font-bold">{icon}</span>
      <span>{message}</span>
      <button
        onClick={onClose}
        className="ml-auto pl-2 hover:opacity-80 transition-opacity"
        aria-label="Dismiss"
      >
        ✕
      </button>
    </div>
  );
};

export default Toast;
